export default __webpack_public_path__ + "static/media/download-visual3.111fab5e.png";